











































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { Route } from 'vue-router'

import {
  ConfirmLeaveModal,
  NetworkErrorEmptyState,
  OptionForm,
  VsLoading
} from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  ModalState,
  Option,
  OptionContext,
  OptionResourcePayload
} from '@/models'

@Component({
  components: {
    ConfirmLeaveModal,
    MobileLayout,
    NetworkErrorEmptyState,
    OptionForm,
    VsLoading
  }
})
export default class OptionDetails extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Number, required: true })
  readonly optionGroupId!: number

  @Prop({ type: Number, required: true })
  readonly optionId!: number

  loadState = new AsyncState()
  updateOptionState = new AsyncState()
  confirmLeaveState = new ModalState()

  data: OptionResourcePayload | null = null
  isValid = false
  previousRoute: string | null = null

  get buttons (): ActionButton[] {
    if (this.option === null) {
      return []
    }

    return [
      {
        text: 'Salvar',
        handler: this.handleSubmit,
        isDisabled: !this.hasChanges || !this.isValid || this.updateOptionState.isPending
      }
    ]
  }

  get context (): OptionContext {
    return {
      id: this.optionId,
      optionGroupId: this.optionGroupId,
      itemGroupId: this.itemGroupId
    }
  }

  get hasChanges () {
    const data = this.data
    const option = this.option

    return data !== null && option !== null && (
      data.name !== option.name ||
      data.description !== option.description ||
      data.price !== option.price ||
      data.available !== option.isAvailable
    )
  }

  get option (): Option | null {
    return this.optionByContext(this.context)
  }

  @Getter('menu/optionByContext')
  readonly optionByContext!: (context: OptionContext) => Option | null

  @Action('menu/loadOption')
  loadOption!: (context: OptionContext) => Promise<void>

  @Action('menu/updateOption')
  updateOption!: (data: { id: number; payload: OptionResourcePayload }) => Promise<void>

  beforeRouteEnter (to: Route, from: Route, next: Function) {
    next((vm: this) => {
      vm.previousRoute = from.name ?? null
    })
  }

  async created () {
    if (this.option === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.option) {
      this.data = {
        groupId: this.optionGroupId,
        name: this.option.name,
        description: this.option.description,
        price: this.option.price,
        available: this.option.isAvailable
      }
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadOption(this.context)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    try {
      await this.updateOptionState.handle(
        this.updateOption({
          id: this.optionId,
          payload: this.data
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.goBack()
    }
  }

  goBack () {
    if (this.previousRoute === 'OptionGroupDetails') {
      this.$router.replace({ name: 'Options' })
    } else {
      this.$router.back()
    }
  }
}
